import styled from 'styled-components';
import { Text12Light, Text14Light } from '../../Text/Text.styles';
import { theme } from '../../../../styles/constants';

export const StyledLabel = styled.label`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  opacity: ${props => (props.disabled ? 0.8 : 1)};
`;

export const LabelText = styled(Text12Light)``;

export const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  position: relative;
  width: fit-content;
  margin-bottom: 0.4rem;
`;

export const TooltipContainer = styled.div`
  border-radius: 12px;
  border: 1px solid #badaf7;
  background: #d8eaf9;
  padding: 1.2rem;
  position: absolute;
  width: 24rem;
  right: 0;
  bottom: 2rem;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  z-index: 1000;
`;

export const TooltipText = styled(Text14Light)`
  opacity: 0.8;
  line-height: 20px;
  letter-spacing: -0.408px;
`;

export const StyledTextarea = styled.textarea`
  font-size: 1.4rem;
  line-height: normal;
  font-weight: 400;
  color: ${theme.colors.textColor};
  background: ${theme.colors.white};
  height: 9rem;
  width: 100%;
  border-radius: 8px;
  border: 1px solid #f3f4f6;
  padding: 0.8rem;
  box-shadow: none;
  outline: none;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'auto')};
  resize: none;

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    -webkit-transition: 'color 9999s ease-out, background-color 9999s ease-out';
    -webkit-transition-delay: 9999s;
  }

  &::placeholder {
    color: #0b3a5f;
    font-weight: 300;
  }
`;

export const StyledInput = styled.input`
  font-size: 1.4rem;
  line-height: normal;
  font-weight: 400;
  color: ${theme.colors.textColor};
  background: ${theme.colors.white};
  height: 3.6rem;
  width: 100%;
  border-radius: 8px;
  border: 1px solid #f3f4f6;
  padding: 0.8rem 3.8rem 0.8rem 0.8rem;
  padding-right: ${props => (props.type === 'password' || props.$isShown || props.$rightIcon ? '5rem' : '0')};
  padding-left: ${props => (props.$leftIcon ? '3.2rem' : '1.2rem')};
  box-shadow: none;
  outline: none;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'auto')};

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    -webkit-transition: 'color 9999s ease-out, background-color 9999s ease-out';
    -webkit-transition-delay: 9999s;
  }

  &::placeholder {
    color: #0b3a5f;
    font-weight: 300;
  }
`;

export const RightIconContainer = styled.div`
  position: absolute;
  min-height: 2rem;
  min-width: 2rem;
  top: ${props => (props.$rightIconLoader ? '2.4rem' : '2.8rem')};
  right: ${props => (!props.$rightIconLoader ? '0.8rem' : '0')};
  cursor: pointer;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
`;

export const Loader = styled.img`
  width: 3.6rem;
`;

export const ErrorContainer = styled.div`
  color: ${theme.colors.error};
  font-size: 1rem;
  min-height: 1.3rem;
  letter-spacing: 0.5px;
  margin-left: 0.2rem;
  font-weight: 300;
`;
